import { getClientApiUrl, getDynamicData, post, batchEmit } from '@avensia/excite';

type CommandTypes = Excite.Commercetools.CustomerCommandTypes['$type'];

type UnknownCommand<TType extends string> = Excite.Commercetools.CustomerCommand & {
  $type: TType;
  [key: string]: any;
};

type Command<TType extends string> = { $type: TType } extends { $type: CommandTypes | '' }
  ? Excite.Commercetools.CustomerCommandTypes
  : UnknownCommand<TType>;

const queue: Excite.Commercetools.CustomerCommandTypes[] = [];
let currentUpdate: Promise<Excite.Commercetools.CustomerCommandResponse> | undefined;
let lastUpdate: Promise<Excite.Commercetools.CustomerCommandResponse> | undefined;

export function send(
  command: Excite.Commercetools.CustomerCommandTypes,
): Promise<Excite.Commercetools.CustomerCommandResponse>;

export function send<TType extends string>(
  command: Command<TType>,
): Promise<Excite.Commercetools.CustomerCommandResponse>;

export function send(command: Excite.Commercetools.CustomerCommandTypes) {
  queue.push(command);

  const customer = getDynamicData<Excite.Commercetools.ICustomerApiModel>();

  if (!currentUpdate) {
    const update = (currentUpdate = lastUpdate = new Promise((resolve, reject) => {
      requestAnimationFrame(async () => {
        const currentQueue = queue.slice();
        queue.length = 0;
        currentUpdate = undefined;

        try {
          batchEmit(() => {
            customer.loading.emit(true);
          });

          const request = await post(getClientApiUrl('ct/customer/apply'), currentQueue);

          const customerResponse: Excite.Commercetools.CustomerCommandResponse = await request.json();

          // Emit after last update so optimistic updates doesn't get interrupted
          if (update === lastUpdate) {
            batchEmit(() => {
              if (customerResponse.customer && customerResponse.success) {
                customer.emit(customerResponse.customer);
              }

              customer.loading.emit(false);
              customer.brodcastRefreshToOtherTabsAndWindows();
            });
          }

          resolve(customerResponse);
        } catch (e) {
          reject(e);
        }
      });
    }));
  }

  return currentUpdate;
}
